/*
 Copyright 2017-2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.

 Licensed under the Amazon Software License (the "License"). You may not use this file
 except in compliance with the License. A copy of the License is located at

 http://aws.amazon.com/asl/

 or in the "license" file accompanying this file. This file is distributed on an "AS IS"
 BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
 License for the specific language governing permissions and limitations under the License.
 */

/**
 * Entry point for sample application.
 * See lex-web-ui.js for the component entry point.
 */

import Vue from 'vue';
import i18n from '@/assets/language';
import router from '@/router';
import LexApp from '@/LexApp';
import store from '@/store';
import $ from 'jquery'

import api from './api';
 
Vue.prototype.$api = api

window.jQuery = $
window.$ = $
// require('../package.json').version
const VUE_APP_VERSION = '1.0.0';
// const vers = window.localStorage.getItem("Version");
// if(vers && VUE_APP_VERSION === vers){
  // localStorage.clear()
  window.localStorage.setItem("Version", VUE_APP_VERSION);
  // location.reload()
// }


/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(LexApp),
  beforeCreate() {
    //安装全局事件总线，$bus就是当前应用的vm
    Vue.prototype.$bus = this
  },

}).$mount('#lex-app');

Vue.config.errorHandler = (err, vm, info) => {
  // eslint-disable-next-line no-console
  console.error('unhandled error in lex-app: ', err, vm, info);
};
